<script>
    import HomePage from './pages/HomePage.svelte'
    import CreatePage from './pages/CreatePage.svelte'
    import CheckoutPage from './pages/CheckoutPage.svelte'
    import ThankYouPage from './pages/ThankYouPage.svelte'
    import ErrorPage from './pages/ErrorPage.svelte'
    import AboutPage from './pages/AboutPage.svelte'
    import PrivacyPage from './pages/PrivacyPage.svelte'
    import FaPlus from 'svelte-icons/fa/FaPlus.svelte'
    import FaShoppingBag from 'svelte-icons/fa/FaShoppingBag.svelte'
    import {cartStore} from './model/stores'
    import {Router, Link, Route} from 'svelte-routing'

    export let url = ''
    import firebase from 'firebase/app'
    import 'firebase/functions'
    import 'firebase/analytics'
    import Footer from './components/Footer.svelte'

    // Can deprecate in the future when no-one is using 'false' as the cartStore.
    if (!Array.isArray($cartStore)) cartStore.set([])
    firebase.initializeApp({
        apiKey: 'AIzaSyCmr0zH8_93s35H1uWKnM22TPU7NYoycUM',
        authDomain: 'post-a-note-backend.firebaseapp.com',
        databaseURL: 'https://post-a-note-backend.firebaseio.com',
        projectId: 'post-a-note-backend',
        storageBucket: 'post-a-note-backend.appspot.com',
        messagingSenderId: '853933492562',
        appId: '1:853933492562:web:aa1ccf096a57f29b0dd28b',
        measurementId: 'G-LVRPRPNENK'
    })
    firebase.analytics()
    if ('__STAGE__' === 'dev') {
        firebase.functions().useFunctionsEmulator('http://localhost:5001')
    }

</script>

<style>
    .links a {
        font-weight: 600;
        background: #EDF2F7;
        padding: 0.2rem 0.5rem;
        border-radius: 4px;
        display: flex;
    }

    .icon.small {
        font-size: 0.9em;
    }

    .navbar {
        border-bottom: var(--gray) 1px solid;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .links a.cartLink {
        font-weight: bold;
    }

    main, .container {
        min-height: 100vh;
    }

    .large {
        display: none;
    }

    @media (min-width: 25em) {
        .large {
            display: block;
        }
    }
</style>
<main>
    <!--    <div class="content">-->
    <div class="container mx-auto flex flex-column flex-auto">
        <nav class="navbar flex items-center white bg-black">
            <div class="flex-none">
                <a href="/" class="btn py2 logo">📮 Post A Note</a>
            </div>
            <div class="flex-auto"></div>
            <div class="links flex self-end">
                <a href="/new" class="inkText underline items-center"><span class="icon small"><FaPlus/></span>New <span
                        class='large'>Message</span></a>
                {#if $cartStore.length > 0}
                    <a href="/checkout" class="inkText cartLink ml1 underline items-center"><span class="icon small"><FaShoppingBag/></span>Cart({$cartStore.length}
                        )</a>
                {/if}
            </div>

        </nav>


        <Router url="{url}">
            <Route path="/" component="{HomePage}"/>
            <Route path="/new" component="{CreatePage}"/>
            <Route path="/checkout" component="{CheckoutPage}"/>
            <Route path="/edit">
                <CreatePage loadOrder="load"/>
            </Route>
            <Route path="/thankyou" component="{ThankYouPage}"/>
            <Route path="/about" component="{AboutPage}"/>
            <Route path="/contact" component="{AboutPage}"/>
            <Route path="/terms" component="{PrivacyPage}"/>
            <Route path="/privacy" component="{PrivacyPage}"/>
            <Route path="/error" component="{ErrorPage}"/>
            <Route component={HomePage}/>
        </Router>
        <div class="flex flex-auto"></div>
        <Footer/>
    </div>
    <!--    </div>-->
</main>